/**
 * Authentication uses the existing Better Auth backend (session cookie). There is no second auth
 * system here: the session is read through api.session (getSession operation) and sign-in/out
 * go through the contract's signInEmail/signOut operations. See src/api/session.ts.
 */
export function safeRedirect(target: unknown, fallback = "/overview"): string {
  if (typeof target !== "string" || !target.startsWith("/") || target.startsWith("//") || target.startsWith("/\\") || target.startsWith("/login"))
    return fallback;
  return target;
}
